import React from 'react';
import { Box, Container, Grid, Typography, Link, IconButton, Divider } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: '#fffafb',
        pt: 8,
        pb: 4,
        borderTop: '1px solid #fcf4f4',
        color: '#5c434a'
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} sx={{ mb: 6 }}>
          {/* About Section */}
          <Grid item xs={12} md={4}>
            <Typography
              variant="h5"
              sx={{
                fontFamily: '"Playfair Display", serif',
                fontWeight: 700,
                color: '#d46a89',
                mb: 2
              }}
            >
              Slice of Sweet
            </Typography>
            <Typography sx={{ fontFamily: '"Outfit", sans-serif', color: '#8c7077', lineHeight: 1.8, maxWidth: '300px' }}>
              Crafting joy, one slice at a time. We specialize in premium cakes and cupcakes made with the finest ingredients and a pinch of love.
            </Typography>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={6} md={2}>
            <Typography
              variant="h6"
              sx={{
                fontFamily: '"Playfair Display", serif',
                fontWeight: 600,
                mb: 2,
                fontSize: '1.1rem'
              }}
            >
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {['Home', 'Menu', 'About', 'Cart'].map((item) => (
                <Link
                  key={item}
                  component={RouterLink}
                  to={item === 'Home' ? '/' : `/${item.toLowerCase()}`}
                  sx={{
                    color: '#8c7077',
                    textDecoration: 'none',
                    fontFamily: '"Outfit", sans-serif',
                    '&:hover': { color: '#e88ba9' }
                  }}
                >
                  {item}
                </Link>
              ))}
            </Box>
          </Grid>

          {/* Customer Support */}
          <Grid item xs={6} md={2}>
            <Typography
              variant="h6"
              sx={{
                fontFamily: '"Playfair Display", serif',
                fontWeight: 600,
                mb: 2,
                fontSize: '1.1rem'
              }}
            >
              Customer Support
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {['Contact Us', 'Privacy Policy'].map((item) => (
                <Link
                  key={item}
                  href="#"
                  sx={{
                    color: '#8c7077',
                    textDecoration: 'none',
                    fontFamily: '"Outfit", sans-serif',
                    '&:hover': { color: '#e88ba9' }
                  }}
                >
                  {item}
                </Link>
              ))}
            </Box>
          </Grid>

          {/* Contact Info */}
          <Grid item xs={12} md={4}>
            <Typography
              variant="h6"
              sx={{
                fontFamily: '"Playfair Display", serif',
                fontWeight: 600,
                mb: 2,
                fontSize: '1.1rem'
              }}
            >
              Get in Touch
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <LocationOnIcon sx={{ color: '#e88ba9', fontSize: 20 }} />
                <Typography sx={{ fontFamily: '"Outfit", sans-serif', color: '#8c7077', fontSize: '0.95rem' }}>
                  123 Bakery Lane, Colombo
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <PhoneIcon sx={{ color: '#e88ba9', fontSize: 20 }} />
                <Typography sx={{ fontFamily: '"Outfit", sans-serif', color: '#8c7077', fontSize: '0.95rem' }}>
                  +94 77 123 4567
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <EmailIcon sx={{ color: '#e88ba9', fontSize: 20 }} />
                <Typography sx={{ fontFamily: '"Outfit", sans-serif', color: '#8c7077', fontSize: '0.95rem' }}>
                  sliceofsweet@gmail.com
                </Typography>
              </Box>
            </Box>

            {/* Social Icons */}
            <Box sx={{ mt: 3, display: 'flex', gap: 1 }}>
              <IconButton sx={{ bgcolor: '#ffedf4', color: '#e88ba9', '&:hover': { bgcolor: '#e88ba9', color: '#white' } }}>
                <InstagramIcon fontSize="small" />
              </IconButton>
              <IconButton sx={{ bgcolor: '#ffedf4', color: '#e88ba9', '&:hover': { bgcolor: '#e88ba9', color: '#white' } }}>
                <FacebookIcon fontSize="small" />
              </IconButton>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ borderColor: '#fcf4f4', mb: 3 }} />

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
          <Typography sx={{ fontFamily: '"Outfit", sans-serif', color: '#8c7077', fontSize: '0.85rem' }}>
            © 2024 Slice of Sweet. All rights reserved.
          </Typography>
          <Typography sx={{ fontFamily: '"Outfit", sans-serif', color: '#8c7077', fontSize: '0.85rem' }}>
            Designed with ♥ for Sweet Lovers
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
